import TagSelect from "./tagSelect.container";

export default TagSelect;
